import { render, staticRenderFns } from "./moral.vue?vue&type=template&id=409336bd"
import script from "./moral.vue?vue&type=script&lang=js"
export * from "./moral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports